// Copyright (c) 2016 Deere & Company

import {Component, PropTypes} from 'react';

class Favicon extends Component {

    componentDidUpdate() {

        document.getElementById('favicon').href = this.props.url;

    }

    render = () => null

}

Favicon.displayName = 'SapEnvironments';
Favicon.propTypes = {
    url: PropTypes.string.isRequired
};

export default Favicon;



// WEBPACK FOOTER //
// ./src/app/favicon.js